/* eslint-disable no-param-reassign */
import clonedeep from 'lodash.clonedeep';

class NWEAError extends Error {
    constructor(props, ...params) {
        super(...params);

        const { code, payload, stringLocale } = props;
        this.code = code;
        if (stringLocale && stringLocale.errors[code]) {
            this.message = `NWEAError - ${stringLocale.errors[code].header} ${stringLocale.errors[code].description}`;
        }

        this.log = () => {
            console.error(this);
        };
    }

    /**
     * Scrub restricted/unwanted data from payload.
     *
     * Restricted Data Requiring faker replacements or removal:
     *  - Name (First, Last, Middle)
     *  - Number/ID
     *  - Gender
     *  - DOB
     *  - Ethnicity
     *  - Email Address
     *  - Disability
     *  - Socioeconomic Information (*Income, education (school, class, grade, enrollment date, score), occupation, wealth, health, political status, language)
     *  - Voice recording
     *  - IP address (We may want to push back on this.  IP address is not necessarily identifying and is necessary for catching malicious intent)
     *  - Geolocation Information (Same for this, we may be able to cut out how specific this is as well to only get a general area)
     * @param payload - state/props payload to be uploaded to Datadog
     */
    static scrubPayload(payload) {
        // Clone the payload so that we do not mutate it
        const clonedPayload = clonedeep(payload);
        // define scrubbing functions here
        const removeKey = (attributeName, objectToScrub) => {
            delete objectToScrub[attributeName];
        };

        // Check the payload for black-listed items and fake/remove them
        // TODO this app currently does not contain any restricted data however should it ever contain any we need to scrub/anonymize it here
        // The blacklist should contain a list of keys which need scrubbed, and a scrub function for each,
        // the scrub function should be applied to the key.  This way we can remove keys or use faker to anonymize them etc.
        const blackList = [{ key: 'children', scrubFunction: removeKey }];

        const scrubSet = (setToScrub) => {
            return [...setToScrub].reduce((acc, setValue) => {
                if (setValue instanceof Set) {
                    acc.push(scrubSet(setValue));
                } else if (setValue instanceof Map) {
                    acc.push(scrubMap(setValue)); // eslint-disable-line no-use-before-define
                } else if (setValue instanceof Object) {
                    acc.push(scrubObject(setValue)); // eslint-disable-line no-use-before-define
                } else {
                    acc.push(setValue);
                }
                return acc;
            }, []);
        };

        const scrubMap = (mapToScrub) => {
            return [...mapToScrub].reduce((acc, mapKeyValuePair) => {
                if (mapKeyValuePair[1] instanceof Map) {
                    mapKeyValuePair[1] = scrubMap(mapKeyValuePair[1]);
                } else if (mapKeyValuePair[1] instanceof Set) {
                    mapKeyValuePair[1] = scrubSet(mapKeyValuePair[1]);
                } else if (mapKeyValuePair[1] instanceof Object) {
                    mapKeyValuePair[1] = scrubObject(mapKeyValuePair[1]); // eslint-disable-line no-use-before-define
                }
                acc.push(mapKeyValuePair);
                return acc;
            }, []);
        };

        const scrubObject = (objectToScrub) => {
            if (objectToScrub) {
                Object.keys(objectToScrub).forEach((key) => {
                    const blackListItem = blackList.find((item) => item.key === key);
                    if (blackListItem) {
                        blackListItem.scrubFunction(key, objectToScrub);
                    } else if (objectToScrub[key] instanceof Function) {
                        delete objectToScrub[key];
                    } else if (objectToScrub[key] instanceof Map) {
                        objectToScrub[key] = scrubMap(objectToScrub[key]);
                    } else if (objectToScrub[key] instanceof Set) {
                        objectToScrub[key] = scrubSet(objectToScrub[key]);
                    } else if (objectToScrub[key] instanceof Object) {
                        objectToScrub[key] = scrubObject(objectToScrub[key]);
                    }
                });
            }

            return objectToScrub;
        };

        return scrubObject(clonedPayload);
    }
}

export default NWEAError;
